// Email notification types a user can opt out of. Mirrors the backend
// NotificationType enum (backend/app/models/__init__.py). Shared by the in-app
// Notification Settings and the public no-login Unsubscribe page so the labels
// never drift apart.
export interface NotificationTypeMeta {
  id: string;
  label: string;
  description: string;
}

export const NOTIFICATION_TYPES: NotificationTypeMeta[] = [
  {
    id: 'team_added_email',
    label: 'Team Added Emails',
    description: "Receive email when you're added to a team",
  },
  {
    id: 'lineup_notification',
    label: 'Lineup Notifications',
    description: 'Receive email when lineup is published for matches',
  },
  {
    id: 'captain_invitation',
    label: 'Captain Invitations',
    description: 'Receive email when invited to be a team captain',
  },
  {
    id: 'lineup_confirmation_reminder',
    label: 'Lineup Confirmation Reminders',
    description: 'Receive reminder emails to confirm your spot in a published lineup',
  },
  {
    id: 'captain_publish_reminder',
    label: 'Captain Publish Reminders',
    description: "Captains only: reminders to publish your team's lineup before a match",
  },
];
